import styled from "styled-components";

export const TimePickerStyles = styled.div`
  width: 100%;

  .error {
    border: 1px solid ${({ theme }) => theme.colors.semantic.text.error} !important;
  }

  .errorMessage {
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.caption.c1.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b1.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.error};
    margin-top: ${({ theme }) => theme.spacing[4]};
    height: 24px;
  }

  .input {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    border-radius: ${({ theme }) => theme.radius[4]};
    padding: ${({ theme }) => theme.spacing[8]};
    cursor: pointer;

    .valueContainer {
      display: flex;
      align-items: center;

      .value {
        font-style: normal;
        font-weight: ${({ theme }) => theme.typography.body.b2.weight};
        font-size: ${({ theme }) => theme.typography.body.b2.size};
        line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
        color: ${({ theme }) => theme.colors.semantic.text.strong};
      }

      .placeholder {
        font-style: normal;
        font-weight: ${({ theme }) => theme.typography.body.b2.weight};
        font-size: ${({ theme }) => theme.typography.body.b2.size};
        line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
        color: ${({ theme }) => theme.colors.semantic.text.placeholder};
      }
    }
  }

  /* Dropdown overrides */
  .react-datepicker-popper {
    z-index: 100;
  }

  .react-datepicker {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default} !important;
    border-radius: ${({ theme }) => theme.radius[12]} !important;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
    overflow: hidden;
  }

  .react-datepicker__triangle {
    display: none !important;
  }

  .react-datepicker__header--time {
    display: none !important;
  }

  .react-datepicker__time-container {
    width: 170px !important;
    border-radius: ${({ theme }) => theme.radius[12]} !important;
    border-left: none !important;
  }

  .react-datepicker__time-container .react-datepicker__time {
    border-radius: ${({ theme }) => theme.radius[12]} !important;
    background: ${({ theme }) => theme.colors.semantic.container.white};
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box {
    width: 100% !important;
    overflow-y: auto;
    border-radius: ${({ theme }) => theme.radius[12]} !important;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list {
    padding: ${({ theme }) => theme.spacing[8]} ${({ theme }) => theme.spacing[12]} ${({ theme }) => theme.spacing[8]} 5px !important;
    margin: 0 !important;
    display: flex;
    flex-direction: column;
    gap: 2px;
    list-style: none;
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100% !important;
    box-sizing: border-box;
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.body.b2.weight};
    font-size: 13px;
    line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    border-radius: ${({ theme }) => theme.radius[4]};
    padding: 8px 12px;
    height: auto !important;
    border: none;
    transition: background 0.15s ease;
    margin: 0;

    &:hover {
      background: ${({ theme }) => theme.colors.accent[50]};
    }
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--selected {
    background-color: transparent !important;
    color: ${({ theme }) => theme.colors.semantic.text.strong} !important;
    border: none !important;
    font-weight: ${({ theme }) => theme.typography.body.b2.weight} !important;
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--disabled {
    color: ${({ theme }) => theme.colors.primary[200]} !important;
  }

  .react-datepicker-wrapper {
    display: flex;
  }

  .react-datepicker__input-container {
    width: 100%;
  }
`;
